<template>
<b-row>
    <b-col cols="12">
      <b-btn class="dashboard-btn" variant="outline-primary" @click.stop="backToDashboard()">Dashboard</b-btn>
      <b-btn class="logout-btn" variant="outline-danger" v-on:click="logout">Logout</b-btn>
      <div class="welcome-message">
        Currently logged in as:  <b>{{ getCurrentUser() }}</b>
        </div>

      <b-jumbotron class="members-section" bg-variant="white" border-variant="black">
        <div class="members-title">
            Members List
        </div>
        
        <div class='add-div'>
          <b-btn class="add-btn" variant="outline-success" @click.stop="addMember()">Add New Member</b-btn>
        </div>
        
        <b-table striped hover sortBy="last_name" sortAsc="false" :items="members" :fields="fields">
          <template slot="actions" slot-scope="row">
              <b-btn variant="outline-primary" size="md" @click.stop="view(row.item)">View/Edit</b-btn>
          </template>
        </b-table>
      </b-jumbotron>
    </b-col>
  </b-row>
</template>



<script>

import firebase from '../Firebase'
import router from '../router/index.js'

export default {
  name: 'MemberList',
   data () {
    return {
      fields: {
        first_name: { label: 'First Name', sortable: true, 'class': 'text-left' },
        last_name: { label: 'Last Name', sortable: true, 'class': 'text-left' },
        address_1: { label: 'Address Line 1', sortable: false, 'class': 'text-left' },
        address_2: { label: 'Address Line 2', sortable:false, 'class': 'text-left' },
        city: { label: 'City', sortable: true, 'class': 'text-left' },
        postcode: { label: 'Post Code', sortable: true, 'class': 'text-left' },
        mobile_no: { label: 'Mobile No.', sortable: false, 'class': 'text-left' },
        membership: { label: 'Membership Level', sortable: true, 'class': 'text-left' },
        probation: { label: 'On Probation?', sortable: true, 'class': 'text-left' },
        member_since: { label: 'Member Since', sortable: true, 'class': 'text-left' },
        actions: { label: '', 'class': 'text-center' }
      },
      members: [],
      errors: [],
      currentUser: firebase.auth().currentUser,
      scrolled: false,
      ref: firebase.firestore().collection('members'),
    }
  },
  created () {
    this.ref.onSnapshot((querySnapshot) => {
      this.members = [];
      querySnapshot.forEach((doc) => {
        this.members.push({
          key: doc.id,
          first_name: doc.data().first_name,
          last_name: doc.data().last_name,
          address_1: doc.data().address_1,
          address_2: doc.data().address_2,
          city: doc.data().city,
          postcode: doc.data().postcode,
          mobile_no: doc.data().mobile_no,
          membership: doc.data().membership,
          probation: doc.data().probation,
          member_since: doc.data().member_since
        });
      });
    });
  },
methods: {
    view (member) {
      router.push({ name: 'ShowMember', params: { id: member.key }})
    },

    backToDashboard() {
      router.push({ name: 'Dashboard'})
    },

    addMember() {
      router.push({ name: 'AddMember'})
    },
    
    getCurrentUser() {
      return this.currentUser.email;
    },

    logout: function() {
      firebase.auth().signOut().then(() => {
        this.$router.replace('Login')
      })
    }
  }
}
</script>

<style>
.members-section {
  height: auto;
  margin-top: 30px;
}
.welcome-message {
  margin-top: 20px;
  font-size: 10pt;
  color: gray;
}
.table {
  width: 96%;
  margin: 0 auto;
}
.dashboard-btn {
  margin-right: 20px;
}
.members-title {
  font-size: 20pt;
  font-weight: bold;
  font-variant: small-caps;
  margin-top: 0px;
}
.add-div {
  margin-top: 10px;
  margin-bottom: 20px;
}
</style>